import React, {Component} from 'react';
import {showlog} from "../../utils";
import {navigateTo, routeTo} from "../../routes";
import {checkLogin} from "../../service/login-service";

export class Login extends Component {

	constructor(props) {
		super(props);

		this.handleValidSubmit = this.handleValidSubmit.bind(this);
		this.state = {
			username: 'test',
			password: 'test',
		};
	}

	handleValidSubmit = async (e) => {
		try {
			// Prevent the browser from reloading the page
			e.preventDefault();

			// Read the form data
			const form = e.target;
			const formData = new FormData(form);
			const formJson = Object.fromEntries(formData.entries());

			const {username = "", password = ""} = formJson;

			// Convert username and password to SHA-256
			const sha256 = require('crypto-js/sha256');
			const hashedUsername = sha256(username).toString();
			const hashedPassword = sha256(password).toString();

			const response = await checkLogin(hashedUsername, hashedPassword);

			routeTo("/welcome")
		} catch (e) {
			showlog("error login", e)
		}
	};

	render() {

		return (
			<React.Fragment>
				<div className="account-pages mt-5 mb-5">
					<div>
						<div className="justify-content-center">
							<div>
								<div>
									<div className="p-4 position-relative">

										<div className="text-center w-75 m-auto">
											<h4 className="text-dark-50 text-center mt-0 font-weight-bold">
												Sign In
											</h4>
											<p className="text-muted mb-4">
												Enter your username and password to access admin panel.
											</p>
										</div>
										<form method="post" onSubmit={this.handleValidSubmit}>
											<div>

												<input
													name="username"
													placeholder="Enter your username"
													required
												/>

												<input
													type="password"
													name="password"
													id="password"
													placeholder="Enter your password"
													required
												/>
											</div>

												<button type="submit" className={"action-button"} style={{marginTop: 10, marginLeft: -10}}>Accedi</button>

										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
			;
	}
}

const mapStateToProps = state => {
	const {user, loading, error} = state.Auth;
	return {user, loading, error};
};
